export default "__VITE_ASSET__6MpZQSme__"